@if (surveyEditor$().activeQuestion) {
  <div [formGroup]="surveyEditor$().activeQuestion" class="input-settings__container">
    <div class="input-settings__box">
      <div class="editor-question-form__input">
        <span class="label">Input Type</span>
        <mat-form-field appearance="outline">
          <mat-select formControlName="inputType">
            <mat-option *ngFor="let inputType of inputTypeLabels | keyvalue" [value]="inputType.key">{{ inputType.value }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="input-settings__box">
      <empathy-required-setting [activeQuestion]="surveyEditor$().activeQuestion"></empathy-required-setting>
      <empathy-min-view-time-setting [activeQuestion]="surveyEditor$().activeQuestion"></empathy-min-view-time-setting>
      @if (surveyEditor$().activeQuestion.get('inputType').value === inputType.Text) {
        <div class="input-settings__input-containers">
          <div class="editor-question-form__input">
            <span class="label"> Min response length </span>
            <span class="sublabel">Set the minimum number of characters required. (Enter 0 for no minimum.) </span>
            <mat-form-field appearance="outline">
              <input matInput type="number" formControlName="minTextLength" />
            </mat-form-field>
          </div>

          <div class="editor-question-form__input">
            <span class="label"> Max response length </span>
            <span class="sublabel">Set the maximum number of characters allowed. (Enter 0 for no maximum.)</span>
            <mat-form-field appearance="outline">
              <input matInput type="number" formControlName="maxTextLength" />
            </mat-form-field>
          </div>
        </div>
      }

      @if (surveyEditor$().activeQuestion.get('inputType').value === inputType.Numbers) {
        <div class="input-settings__input-containers">
          <div class="editor-question-form__input">
            <span class="label"> Min response length </span>
            <span class="sublabel">When the value is 0 the setting does not apply</span>
            <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
              <input matInput type="number" formControlName="minLength" />
            </mat-form-field>
          </div>

          <div class="editor-question-form__input">
            <span class="label"> Max response length </span>
            <span class="sublabel">When the value is 0 the setting does not apply</span>
            <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
              <input matInput type="number" formControlName="maxLength" />
            </mat-form-field>
          </div>
        </div>
      }
    </div>

    <empathy-media-settings [activeQuestion]="surveyEditor$().activeQuestion"></empathy-media-settings>
  </div>
}
